export let _roles = [];
let _captureRole = "";
let _userId = "";
let _tenantName = "";
let _agent = "";
let _clientId = "";
let _group = [];

export const UserService = {
    getRoles: () => _roles,
    setRoles: (roles) => _roles = roles,
    getCaptureRole: () => _captureRole,
    setCaptureRole: (role) => _captureRole = role,
    getUserId: () => _userId,
    setUserId: (userId) => _userId = userId,
    setTenant: (iss) => {
      if(iss && typeof iss === 'string') {
        _tenantName = iss.slice(iss.lastIndexOf("/") + 1);
      }
    },
    getTenantName: () => _tenantName,
    getAgent: () => _agent,
    setAgent: (agent) => _agent = agent,
    getClientId: () => _clientId,
    setClientId: (clientId) => _clientId = clientId,
    getGroup: () => _group,
    setGroup: (group) => _group = group
};